import { api } from "./api";

const ENDPOINT =
  process.env.REACT_APP_ENVIRONMENT === 'production'
    ? process.env.REACT_APP_BASE_URL_API_SERVER_PROD
    : process.env.REACT_APP_BASE_URL_API_SERVER_TEST;

export async function enviarCodigoConfirmacao(cpf, numero, nome) {
  if (!cpf || !numero || !nome) {
    throw new Error('CPF, número de telefone e nome são obrigatórios');
  }

  const response = await api(`${ENDPOINT}/whatsapp/confirmacao_telefone`, {
    credentials: 'include',
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({
      cpf,
      numero,
      nome
    }),
  });

  return await response.json();
}

export async function enviarCodigoRecuperacao(cpf, numero, nome = null) {
  if (!cpf || !numero) {
    throw new Error('CPF e número de telefone são obrigatórios');
  }

  const response = await api(`${ENDPOINT}/whatsapp/recupera_senha`, {
    credentials: 'include',
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({
      cpf,
      numero,
      nome: nome ? nome : 'CLIENTE',
    }),
  });

  return await response.json();
}